export default {
    label: {
        marginRight: "5px",
        cursor: "pointer"
    },

    dropdownMenu: {
        width: "100%",
        margin: "5px 0px 0px 0px"
    },

    buttonsContainer: {
        display: "flex",
        alignItems: "center",
        padding: "8px 16px 2px",
        columnGap: "10px",
        borderTop: "0.5px solid #BEBEBE"
    },

    button: {
        width: "100%",
        padding: "4px"
    }
}